<template>
  <div class="">
    <b-container>
      <!--  <h5 class="textPlaceholder">Select Support Request Filter</h5>-->
      <b-row>
        <b-col>
          <br />
        </b-col>
      </b-row>
      <b-row>
        <!-- <b-button variant="outline-info">Filter Results</b-button>
        <b-button variant="outline-info">Reset</b-button> -->
        <!-- <b-col>
          <b-button variant="outline-info" v-b-modal.newticket
            >New Ticket</b-button
          >
        </b-col> -->
      </b-row>
      <b-row>
        <b-col>
          <br />
        </b-col>
      </b-row>
      <!-- <b-row> 
        <b-col cols="4" md="4">
          <label for="RequestUrgency">By Urgency:</label>
          <select
            name="RequestUrgency"
            v-model="RequestUrgency"
            id="RequestUrgency"
            @focus="modal = false"
            required
          >
            <option value=""></option>
            <option>Non Urgent</option>
            <option>Routine</option>
            <option>Urgent</option>
            <option>Highly Urgent</option>
          </select>
        </b-col>
        <b-col class="" cols="4" md="4">
          <label for="RequestStatus">By Status:</label>
          <select
            name="RequestStatus"
            v-model="RequestStatus"
            id="RequestStatus"
            @focus="modal = false"
            required
          >
            <option value=""></option>
            <option>New</option>
            <option>Acknowledge</option>
            <option>Under Review</option>
            <option>Responded</option>
            <option>In Progress</option>
            <option>Completed</option>
          </select>
        </b-col>
        <b-col cols="4" md="4"
          ><label for="DateRaised">Date Raised:</label>

          <b-form-datepicker
            type="date"
            v-model="DateRaised"
            @focus="modal = false"
        /></b-col> 
      </b-row>
      <b-col class="line1"> </b-col>

      <b-row class="BottomRow">
        <b-col cols="6" md="6"
          ><label for="“RequestDrop”">Type:</label>
          <select
            name="RequestDrop"
            v-model="RequestDrop"
            id="RequestDrop"
            @focus="modal = false"
            required
          >
            <option value=""></option>
            <option>IT System Alert</option>
            <option>Maintenance Alert</option>
          </select></b-col
        >
        <b-col class="" cols="6" md="6"
          ><label for="Location">Location:</label>
          <select v-model="location">
            <option value="" select disabled>Select Location</option>
            <option
              v-for="(value, id) in this.locationsArray"
              :key="id"
              v-bind:value="{ id: value.id, text: value.location }"
              >{{ value.location }}</option
            >
          </select>
        </b-col>
      </b-row>
      <b-row> </b-row>
      <b-row class="BottomRow">
        <b-col sm>
          <button id="button" class="button" v-on:click="SubmitFilter()">
            Filter
          </button>
          <button id="button" class="button" v-on:click="resetValue()">
            Clear
          </button>
        </b-col>
      </b-row> -->
    </b-container>
    <b-modal
      id="newticket"
      hide-footer
      lazy
      content-class="Modal"
      header-bg-variant="light"
      footer-bg-variant="light"
      title="New Support Ticket"
      ok-only
    >
      <b-card
        border-variant="dark"
        align="center"
        header-bg-variant="secondary"
        footer-tag="footer"
      >
        <template #header>
          <h4>Raise a Support Request</h4>
        </template>
        <b-card-sub-title>
          Use this form to submit any incidents, problems or support requests
        </b-card-sub-title>
        <br />
        <b-card-sub-title>
          Please complete below details
        </b-card-sub-title>
        <br />

        <b-card>
          <b-col cols="12">
            <label>Full Name</label>
          </b-col>
          <input
            id="reqraised"
            type="text"
            placeholder="Request Raised by"
            v-model="userID"
            required
            :readonly="true"
            @focus="modal = false"
          />
          <br />
          <b-col cols="12"><label>Contact Email</label></b-col>
          <input
            id="contactemail"
            maxlength="90"
            type="email"
            placeholder="User Email Address"
            v-model="UserEmail"
            @focus="modal = false"
            required
          />
          <b-col cols="12"><label for="">Request Type</label></b-col>
          <select
            name="RequestDrop"
            v-model="RequestDrop"
            id="RequestDrop"
            @focus="modal = false"
            required
          >
            <option select disabled value=""></option>
            <option>Clarence Software Support</option>
            <option>Maintenance Support</option>
          </select>
          <b-col cols="12"><label for="">Location</label></b-col>
          <input
            type="text"
            placeholder="Location"
            v-model="this.userLocation"
            required
            :readonly="true"
            @focus="modal = false"
          />
          <br />
        </b-card>
        <br />
        <b-card>
          <b-row>
            <b-form-radio-group
              v-model="selected"
              :options="options"
              class="mb-3"
              value-field="item"
              text-field="name"
              disabled-field="notEnabled"
              @focus="modal = false"
            ></b-form-radio-group>
          </b-row>
          <br />
          <b-col cols="12"
            ><label for="">
              Please describe in as much detail as possible the reason for the
              request. (1000 Character Max)</label
            ></b-col
          >

          <textarea
            class="supportTextArea"
            v-model="message"
            placeholder="Description"
            rows="6"
            cols="45"
            @focus="modal = false"
            maxlength="1000"
          ></textarea>
        </b-card>
        <br />
        <b-button variant="outline-info" v-on:click="SubmitSearch()">
          Submit
        </b-button>
        <b-button variant="outline-info" v-on:click="resetSupportActions()">
          Reset
        </b-button>
      </b-card>
    </b-modal>

    <div class="Container">
      <p>Current Open Requests for User</p>
      <br />
      <div id="#">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="Requesttable"
        ></b-pagination>

        <b-table
          id="RequestTable"
          :items="this.items"
          :fields="this.UserHeaders"
          empty-text="You currently dont have any open support requests"
          :per-page="perPage"
          :current-page="currentPage"
          no-border-collapse
          hover
          show-empty
          responsive
          small
          sticky-header
        >
          <template v-slot:empty="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template v-slot:cell(Action)="{ item }">
            <b-button
              variant="outline-info"
              v-on:click="
                showActionModal(
                  item[0],
                  item[1],
                  item[2],
                  item[3],
                  item[4],
                  item[5],
                  item[6],
                  item[7],
                  item[8],
                  item[9],
                  item[10]
                )
              "
            >
              Action
            </b-button>
          </template>
        </b-table>
      </div>
      <b-modal
        ref="SupportActionModal"
        id="SupportActionModal"
        title="Support Action Form"
        content-class="Modal"
        header-bg-variant="light"
        footer-bg-variant="light"
        lazy
        ok-only
        hide-footer
      >
        <b-card
          border-variant="dark"
          align="center"
          header-bg-variant="secondary"
          footer-tag="footer"
        >
          <template #header>
            <h4 class="#">
              Request ID: {{ RequesttobeActioned }} - Raised By:
              {{ UserAction }}
            </h4>
            <h4 class="">
              Request Type: {{ ActionCategory }} - Raised On:
              {{ ActionDate }}
            </h4>
          </template>
          <div v-if="this.ActionCategory != 'Card Generation'">
            <b-card-sub-title class="mb-2"
              >Location: {{ ActionLocation }}</b-card-sub-title
            >

            <b-card-sub-title class="mb-2">
              Urgency: {{ ActionUrgency }} - Status:
              {{ ActionState }}</b-card-sub-title
            >
            <b-card>Details: {{ ActionDetails }}</b-card>

            <br />

            <b-col class="line-col"> </b-col>

            <b-card>
              <b-row>
                <b-col cols="3">
                  <input
                    type="checkbox"
                    id="clearcheckbox"
                    value="Clear"
                    v-model="checkedactions"
                  />
                </b-col>

                <b-col cols="6"
                  ><label for="clearcheckbox"> Clear Request</label></b-col
                >
              </b-row>
              <b-row>
                <b-col cols="3">
                  <input
                    type="checkbox"
                    id="acknowledgecheckbox"
                    value="Acknowledge"
                    v-model="checkedactions"
                  />
                </b-col>

                <b-col cols="6">
                  <label for="acknowledgecheckbox">
                    Acknowledge Request</label
                  ></b-col
                >
              </b-row>

              <b-row>
                <b-col cols="3">
                  <input
                    type="checkbox"
                    id="statuscheckbox"
                    value="UpdateStatus"
                    v-model="checkedactions"
                    v-b-toggle.statuscheckbox
                  />
                </b-col>
                <b-col cols="6">
                  <label for="statuscheckbox">Update Status</label>
                </b-col>
              </b-row>
              <b-collapse id="statuscheckbox">
                <b-card-body>
                  <b-card-sub-title class="" for="StatusUpdate"
                    >Select Updated Status:
                  </b-card-sub-title>
                  <br />
                  <select name="StatusUpdate" v-model="StatusUpdate" id="#">
                    <option value=""></option>
                    <option>Under Review</option>
                    <option>Responded</option>
                    <option>In Progress</option>
                    <option>Completed</option>
                  </select>
                </b-card-body>
              </b-collapse>
              <!-- <input
                type="checkbox"
                id="statuscheckbox"
                value="UpdateStatus"
                v-model="checkedactions"
              />
              <label for="statuscheckbox">Update Status</label> -->
              <b-row>
                <b-col cols="3">
                  <input
                    type="checkbox"
                    id="contactcheckbox"
                    value="Contact"
                    v-model="checkedactions"
                    v-b-toggle.contactcheckbox
                  />
                </b-col>
                <b-col cols="6">
                  <label for="contactcheckbox">Contact User</label>
                </b-col>
              </b-row>
              <!-- <b-button
                    block
                    variant="outline-info"
                    v-model="checkedactions"
                    id="contactcheckbox"
                    value="Contact"
                    v-b-toggle.contactcheckbox
                    >Contact User</b-button
                  > -->

              <b-collapse id="contactcheckbox" accordion="my-accordion">
                <b-card-body>
                  <b-card-sub-title
                    >Complete box with message to be sent to
                    user:</b-card-sub-title
                  >
                  <br />
                  <textarea
                    v-model="messageforcontact"
                    placeholder="Message for email body"
                    rows="6"
                    cols="45"
                  ></textarea>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- <div v-if="checkedactions.includes('Contact')">
              <b-col class="line-col"></b-col>

              <p class="">
                Complete box with message to be sent to user:
              </p>
              <textarea
                v-model="messageforcontact"
                placeholder="Message for email body"
                rows="8"
                cols="40"
                id="EmailBody"
              ></textarea>
            </div> -->

            <div v-if="checkedactions.includes('Service')">
              <p>Complete details below for service request</p>
              <label for="ServiceType">Service Type: </label>
              <select name="ServiceType" v-model="ServiceType" id="ServiceType">
                <option value=""></option>
                <option>Sensor</option>
                <option>Communications</option>
                <option>Water Line</option>
                <option>Electrics</option>
                <option>Mechanical</option>
                <option>Unknown</option>
              </select>
              <br />
              <label for="ServiceAssign">Assign To: </label>
              <select
                name="ServiceAssign"
                v-model="ServiceAssign"
                id="ServiceAssign"
              >
                <option value=""></option>
                <option>Maintenance</option>
                <option>IT Support</option>
              </select>
            </div>
            <br />

            <b-button
              variant="outline-info"
              v-on:click="
                checkmodal(
                  checkedactions,
                  StatusUpdate,
                  messageforcontact,
                  ServiceAssign,
                  ServiceType
                )
              "
            >
              Submit
            </b-button>
            <b-button variant="outline-info" v-on:click="resetSupportActions()">
              Reset
            </b-button>
          </div>

          <!-- <div v-if="this.ActionCategory === 'Card Generation'">
            <b-card-sub-title class="mb-2"
              >Location: {{ ActionLocation }}</b-card-sub-title
            >
            <b-card>
              <template>
                <h4 class="">
                  Request ID: {{ RequesttobeActioned }} - Raised By:
                  {{ UserAction }}
                </h4>
                <h4 class="">
                  Request Type: {{ ActionCategory }} - Raised On:
                  {{ ActionDate }}
                </h4>
              </template>
              <b-card-sub-title class="mb-2">
                Urgency: {{ ActionUrgency }} - Status:
                {{ ActionState }}</b-card-sub-title
              >
              <b-card-body>
                <b-card>Details: {{ ActionDetails }}</b-card>
                <br />
              </b-card-body>
              <ul>
                <li id="check">
                  <input
                    type="checkbox"
                    id="clearcheckbox"
                    value="Clear"
                    v-model="checkedactions"
                  />
                  <label for="clearcheckbox">Delete Request</label>
                </li>
                <li id="check">
                  <input
                    type="checkbox"
                    id="acknowledgecheckbox"
                    value="Acknowledge"
                    v-model="checkedactions"
                  />
                  <label for="acknowledgecheckbox">Acknowledge Request</label>
                </li>
                <li id="check">
                  <input
                    type="checkbox"
                    id="statuscheckbox"
                    value="UpdateStatus"
                    v-model="checkedactions"
                  />
                  <label for="statuscheckbox">Update Status</label>
                </li>
              </ul>
              <br />
              <div v-if="checkedactions.includes('UpdateStatus')">
                <p>Select new status for request</p>
                <label for="StatusUpdate">Updated Status</label>
                <select
                  name="StatusUpdate"
                  v-model="StatusUpdate"
                  id="StatusUpdate"
                >
                  <option value=""></option>

                  <option>Completed</option>
                </select>
              </div>
              <div v-if="checkedactions.includes('Contact')">
                <p>Complete box with message to be sent to user:</p>
                <textarea
                  v-model="messageforcontact"
                  placeholder="Message for email body"
                  cols="6"
                ></textarea>
              </div>
              <div v-if="checkedactions.includes('Service')">
                <p>Complete details below for service request</p>
                <label for="ServiceType">Service Type: </label>
                <select
                  name="ServiceType"
                  v-model="ServiceType"
                  id="ServiceType"
                >
                  <option value=""></option>
                  <option>Sensor</option>
                  <option>Communications</option>
                  <option>Water Line</option>
                  <option>Electrics</option>
                  <option>Mechanical</option>
                  <option>Unknown</option>
                </select>
                <br />
                <label for="ServiceAssign">Assign To: </label>
                <select
                  name="ServiceAssign"
                  v-model="ServiceAssign"
                  id="ServiceAssign"
                >
                  <option value=""></option>
                  <option>Maintenance</option>
                  <option>IT Support</option>
                </select>
              </div>
              <br />
              <button
                class="button"
                v-on:click="
                  checkmodal(
                    checkedactions,
                    StatusUpdate,
                    messageforcontact,
                    ServiceAssign,
                    ServiceType
                  )
                "
              >
                Submit
              </button>
              <button class="button" v-on:click="resetSupportActions()">
                Reset
              </button>
            </b-card>
          </div> -->
        </b-card>
      </b-modal>

      <br />
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  computed: {
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    let PostUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/supportrequests";
    let PostHeaders = this.$apikeyPost;
    let PostData = {
      Location: localStorage.getItem("CurrentLocation"),
      RequestType: "Retrieve",
      SRType: "",
      Urgency: "",
      Status: "",
      Category: "",
      User: "",
      Text: "",
      Email: "",
      Company: localStorage.getItem("Company"),
    };
    axios
      .post(PostUrl, PostData, PostHeaders)
      .then((response) => {
        this.testing = response.data.field_names;
        this.items = response.data.Values;
        for (let i = 0; i < this.testing.length; i++) {
          var QuoteStr = "" + i + "";
          if (i == 0) {
            this.ArrTest.push({
              key: QuoteStr,
              label: this.testing[i],
              sortable: false,
              variant: "primary",
            });
          } else {
            this.ArrTest.push({
              key: QuoteStr,
              label: this.testing[i],
              sortable: false,
            });
          }
        }
        this.UserHeaders = this.ArrTest;
        this.UserHeaders.push("Action");
        this.ArrTest = [];
      })

      .catch((err) => {
        "ERROR: ====", err;
      });
    let LookUpUrl3 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders3 = this.$apikeyPost;
    this.LookUpRequest3 = {
      RequestType: "Location",
      Company: this.CompanyName,
    };

    axios
      .post(LookUpUrl3, this.LookUpRequest3, LookUpHeaders3)
      .then((response) => {
        this.locationslist = response.data.Values;
        for (let i = 0; i < this.locationslist.length; i++) {
          var QuoteStr4 = this.locationslist[i][0];
          this.locationsArray.push({
            id: QuoteStr4,
            location: this.locationslist[i][2],
            address: this.locationslist[i][1],
          });
        }
      });
  },
  data() {
    return {
      options: [
        { item: "Highly Urgent", name: "Highly Urgent (12hr)" },
        { item: "Urgent", name: "Urgent (24hr)" },
        { item: "Routine", name: "Routine (48hr)" },
        { item: "Non Urgent", name: "Non Urgent (1 Week)" },
      ],
      UserHeaders: [],
      items: [],
      response: null,
      ArrTest: [],
      RequestDrop: "",
      location: "",
      RequestUrgency: "",
      RequestStatus: "",
      DateRaised: "",
      locations: [],
      filteredlocation: null,
      filteredlocations: [],
      modal: null,
      perPage: 10,
      currentPage: 1,
      actionmodal: false,
      RequesttobeActioned: "",
      UserAction: "",
      ActionLocation: "",
      ActionCategory: "",
      ActionDate: "",
      ActionUrgency: "",
      ActionAcknowledged: "",
      ActionState: "",
      checkedactions: [],
      messageforcontact: "",
      StatusUpdate: "",
      ServiceAssign: "",
      ServiceType: "",
      SRType: "",
      ActionDetails: "",
      CompanyName: this.$Company,
      UserLocation: this.$Location,
      locationsArray: [],
      locationslist: [],
      locationSearch: "",
      buttonCooldown: false,

      userID: localStorage.getItem("fullname"),
      userLocation: localStorage.getItem("CurrentLocation"),
      selected: "",
      message: "",
      UserEmail: "",
    };
  },
  methods: {
    btnCooldown: function() {
      let buttonid = "button";
      const button = document.querySelector("#" + buttonid + "");
      if (this.buttonCooldown == true) {
        const disableButton = () => {
          button.disabled = true;
        };
        button.addEventListener("click", disableButton);
      } else if (this.buttonCooldown == false) {
        button.disabled = false;
      }
    },

    resetValue() {
      (this.RequestDrop = ""),
        (this.location = ""),
        (this.RequestUrgency = ""),
        (this.RequestStatus = ""),
        (this.DateRaised = ""),
        (this.modal = "false");
      let PostUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/supportrequests";
      let PostHeaders = this.$apikeyPost;
      let PostData = {
        Location: "",
        RequestType: "LoadCompany",
        SRType: "",
        Urgency: "",
        Status: "",
        Category: "",
        User: "",
        Text: "",
        Email: "",
        Company: localStorage.getItem("Company"),
      };
      axios
        .post(PostUrl, PostData, PostHeaders)
        .then((response) => {
          this.testing = response.data.field_names;
          this.items = response.data.Values;
          for (let i = 0; i < this.testing.length; i++) {
            var QuoteStr = "" + i + "";
            if ((i == 0) | (i == 7)) {
              this.ArrTest.push({
                key: QuoteStr,
                label: this.testing[i],
                sortable: false,
              });
            } else {
              this.ArrTest.push({
                key: QuoteStr,
                label: this.testing[i],
                sortable: false,
              });
            }
          }
          this.UserHeaders = this.ArrTest;
          this.UserHeaders.push("Action");
          this.ArrTest = [];
        })
        .catch((err) => {
          "ERROR: ====", err;
        });
    },

    SubmitFilter() {
      this.buttonCooldown = true;

      if (
        (this.DateRaised === "") &
        (this.location === "") &
        (this.RequestUrgency === "") &
        (this.RequestStatus === "") &
        (this.RequestDrop === "")
      ) {
        alert("Please select at least one field to filter on");
        this.buttonCooldown = false;
      } else if (
        (this.RequestUrgency != "") & (this.RequestStatus != "") ||
        (this.RequestUrgency != "") & (this.DateRaised != "") ||
        (this.RequestUrgency != "") & (this.RequestDrop != "") ||
        (this.RequestUrgency != "") & (this.location != "") ||
        (this.RequestStatus != "") & (this.DateRaised != "") ||
        (this.RequestStatus != "") & (this.RequestDrop != "") ||
        (this.RequestStatus != "") & (this.location != "") ||
        (this.DateRaised != "") & (this.RequestDrop != "") ||
        (this.DateRaised != "") & (this.location != "") ||
        (this.RequestDrop != "") & (this.location != "")
      ) {
        alert("Please select only one field to filter on");
        this.buttonCooldown = false;
        this.resetValue();
      } else if (this.location != "") {
        let PostUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/supportrequests";
        let PostHeaders = this.$apikeyPost;
        let NewLocation = this.location;
        let PostData = {
          Location: NewLocation.text,
          RequestType: "Retrieve",
          SRType: this.RequestDrop,
          DateRaised: this.DateRaised,
          Urgency: this.RequestUrgency,
          Status: this.RequestStatus,
          Category: "",
          User: "",
          Text: "",
          Email: "",
          Company: localStorage.getItem("Company"),
        };

        axios
          .post(PostUrl, PostData, PostHeaders)
          .then((response) => {
            this.buttonCooldown = false;
            this.testing = response.data.field_names;
            this.items = response.data.Values;
            for (let i = 0; i < this.testing.length; i++) {
              var QuoteStr = "" + i + "";
              if ((i == 0) | (i == 7)) {
                this.ArrTest.push({
                  key: QuoteStr,
                  label: this.testing[i],
                  sortable: false,
                });
              } else {
                this.ArrTest.push({
                  key: QuoteStr,
                  label: this.testing[i],
                  sortable: false,
                });
              }
            }
            this.UserHeaders = this.ArrTest;
            this.UserHeaders.push("Action");
            this.ArrTest = [];
          })
          .catch((err) => {
            "ERROR: ====", err;
          });
      } else if (
        this.location == "" &&
        (this.RequestUrgency != "" ||
          this.RequestStatus != "" ||
          this.DateRaised != "" ||
          this.RequestDrop != "")
      ) {
        let current = new Date();
        let TodaysDate =
          current.getFullYear() +
          "-" +
          (current.getMonth() + 1) +
          "-" +
          current.getDate();

        if (TodaysDate < this.DateRaised) {
          alert("Please ensure the date selected is not in the future");
          this.buttonCooldown = false;
        } else {
          let PostUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/supportrequests";
          let PostHeaders = this.$apikeyPost;
          let NewLocation = this.location[0];
          let PostData = {
            Location: NewLocation,
            RequestType: "Retrieve",
            SRType: this.RequestDrop,
            DateRaised: this.DateRaised,
            Urgency: this.RequestUrgency,
            Status: this.RequestStatus,
            Category: "",
            User: "",
            Text: "",
            Email: "",
            Company: localStorage.getItem("Company"),
          };
          axios
            .post(PostUrl, PostData, PostHeaders)
            .then((response) => {
              this.buttonCooldown = false;
              this.testing = response.data.field_names;
              this.items = response.data.Values;
              for (let i = 0; i < this.testing.length; i++) {
                var QuoteStr = "" + i + "";
                if ((i == 0) | (i == 7)) {
                  this.ArrTest.push({
                    key: QuoteStr,
                    label: this.testing[i],
                    sortable: false,
                  });
                } else {
                  this.ArrTest.push({
                    key: QuoteStr,
                    label: this.testing[i],
                    sortable: false,
                  });
                }
              }

              this.UserHeaders = this.ArrTest;
              this.UserHeaders.push("Action");
              this.ArrTest = [];
            })
            .catch((err) => {
              "ERROR: ====", err;
            });
        }
      }
    },

    filterLocations: function() {
      if (this.location.length == 0) {
        this.filteredlocations = this.locations;
      }
      this.filteredlocations = this.locations.filter((location) => {
        return location
          .toString()
          .toLowerCase()
          .startsWith(this.location.toString().toLowerCase());
      });
    },

    setLocation(location) {
      this.location = location;
      this.modal = false;
    },

    showActionModal: function(
      RequestID,
      UserName,
      Email,
      RequestLocation,
      RequestDate,
      Urgencylevel,
      RequestCategory,
      State,
      Details,
      isAcknowledged
    ) {
      this.RequesttobeActioned = RequestID;
      this.UserAction = UserName;
      this.UserEmail = Email;

      this.ActionLocation = RequestLocation;
      this.ActionCategory = RequestCategory;
      this.ActionDate = RequestDate;
      this.ActionUrgency = Urgencylevel;
      this.ActionAcknowledged = isAcknowledged;
      this.ActionState = State;
      this.ActionDetails = Details;
      this.$refs["SupportActionModal"].show(
        this.RequesttobeActioned,
        this.UserAction,
        this.ActionLocation,
        this.ActionCategory,
        this.ActionDate,
        this.ActionUrgency,
        this.ActionAcknowledged,
        this.ActionState,
        this.ActionDetails,
        this.UserEmail
      );
    },
    checkmodal(
      checkedactions1,
      StatusUpdate1,
      messageforcontact1,
      ServiceAssign1,
      ServiceType1
    ) {
      if (checkedactions1.length < 1) {
        alert("You must select at least one action");
      } else
        this.submitSupportActions(
          checkedactions1,
          StatusUpdate1,
          messageforcontact1,
          ServiceAssign1,
          ServiceType1
        );
    },
    submitSupportActions(checkedactions1) {
      if (checkedactions1.includes("Contact")) {
        let newMessage = JSON.stringify(this.messageforcontact);
        let newMessage2 = newMessage.replace(/^"|"$/g, "");
        let EmailPostData = {
          ToEmail: this.UserEmail,
          EmailText:
            "Hello " +
            this.UserAction +
            ",\\n\\nYour Support Ticket has a response. \\n\\nResponse to Ticket: " +
            this.RequesttobeActioned +
            "\\n\\nTicket Details: " +
            this.ActionDetails +
            "\\n\\nResponse: " +
            newMessage2 +
            "\\n\\nSent from  App",
          EmailSubject:
            "Support Ticket " + this.RequesttobeActioned + " Response",
        };
        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";
        let EmailPostHeaders = this.$apikeyPost;
        axios
          .post(EmailPosturl, EmailPostData, EmailPostHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => {
            "Error: ===", err;
          });

        this.LookUpRequest = {
          Actions: ["UpdateStatus"],
          RequestID: this.RequesttobeActioned,
          NewStatus: "Responded",
        };
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/supportactions";
        let LookUpHeaders = this.$apikeyPost;

        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            alert("Support Request Status has been updated");

            this.resetValue();
          })
          .catch((err) => {
            "Error: ===", err;
          });
      } else if (checkedactions1.includes("Clear")) {
        this.LookUpRequest = {
          Actions: ["UpdateStatus"],
          RequestID: this.RequesttobeActioned,
          NewStatus: "Cleared",
        };
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/supportactions";
        let LookUpHeaders = this.$apikeyPost;

        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            alert("Support Request Status has been updated");

            this.resetValue();
          })
          .catch((err) => {
            "Error: ===", err;
          });
      } else if (checkedactions1.includes("Acknowledge")) {
        this.LookUpRequest = {
          Actions: ["UpdateStatus"],
          RequestID: this.RequesttobeActioned,
          NewStatus: "Acknowledge",
        };
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/supportactions";
        let LookUpHeaders = this.$apikeyPost;

        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            alert("Support Request Status has been updated");

            this.resetValue();
          })
          .catch((err) => {
            "Error: ===", err;
          });
      } else if (checkedactions1.includes("UpdateStatus")) {
        this.LookUpRequest = {
          Actions: ["UpdateStatus"],
          RequestID: this.RequesttobeActioned,
          NewStatus: this.StatusUpdate,
        };
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/supportactions";
        let LookUpHeaders = this.$apikeyPost;

        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            alert("Support Request Status has been updated");

            this.resetValue();
          })
          .catch((err) => {
            "Error: ===", err;
          });
      }

      /* else if(checkedactions1.includes('Service')){


        this.LookUpRequest = {"Actions":this.checkedactions,"RequestID":this.RequesttobeActioned,"NewStatus":this.StatusUpdate,  "ServiceReason":this.ServiceType,"ServiceAssign":this.ServiceAssign}
        let LookUpUrl = "https://88l7752c0h.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/support"
        let LookUpHeaders = this.$apikeyPost;

        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            (response);
            this.resetValue()


          })
           .catch((err) => {
return err      })
      } */

      this.checkedactions = [];
      this.messageforcontact = "";
      this.StatusUpdate = "";
      this.ServiceAssign = "";
      this.ServiceType = "";
      this.$refs["SupportActionModal"].hide();
    },

    resetSupportActions() {
      this.checkedactions = [];
      this.messageforcontact = "";
      this.StatusUpdate = "";
      this.serviceAssign = "";
      this.serviceType = "";
    },
    refreshTable() {
      let PostUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/supportrequests";
      let PostHeaders = this.$apikeyPost;
      let PostData = {
        Location: "",
        RequestType: "LoadCompany",
        SRType: "",
        Urgency: "",
        Status: "",
        Category: "",
        User: "",
        Text: "",
        Email: "",
        Company: localStorage.getItem("Company"),
      };
      axios.post(PostUrl, PostData, PostHeaders).then((response) => {
        this.testing = response.data.field_names;
        this.items = response.data.Values;
        for (let i = 0; i < this.testing.length; i++) {
          var QuoteStr = "" + i + "";
          if ((i == 0) | (i == 7)) {
            this.ArrTest.push({
              key: QuoteStr,
              label: this.testing[i],
              sortable: false,
            });
          } else {
            this.ArrTest.push({
              key: QuoteStr,
              label: this.testing[i],
              sortable: false,
            });
          }
        }
        this.UserHeaders = this.ArrTest;
        this.UserHeaders.push("Action");
        this.ArrTest = [];
      });
    },
    emailIsValid(email) {
      this.EmailVal = /\S+@\S+\.\S+/.test(email);
    },

    SubmitSearch() {
      if (
        this.RequestDrop === null ||
        this.location === null ||
        this.UserEmail === null ||
        this.Message === null
      ) {
        this.buttonCooldown = false;

        alert("Please complete all fields before submitting");
      } else if (this.UserEmail != null) {
        this.emailIsValid(this.UserEmail);
        if (this.EmailVal === false) {
          this.buttonCooldown = false;

          alert("Email Address does not appear to be valid");
        } else {
          if (this.RequestDrop === "Clarence Software Support") {
            this.AlertCategory = "IT System Alert";
          } else if (this.RequestDrop === "Maintenance Support") {
            this.AlertCategory = "Maintenance Alert";
          }

          if (this.userLocation != null) {
            let newMessage = JSON.stringify(this.message);
            let newMessage2 = newMessage.replace(/^"|"$/g, "");

            let user = this.$UserURN;
            let postparam = {
              Location: this.userLocation,
              RequestType: "Submit",
              SRType: this.RequestDrop,
              Urgency: this.selected,
              Status: "New",
              User: user,
              Category: this.AlertCategory,
              Text: newMessage2,
              Email: this.UserEmail,
              Company: "",
              DateRaised: "",
            };
            let PostHeaders = this.$apikeyPost;
            let posturl =
              "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
              this.$environment +
              "/supportrequests";
            axios.post(posturl, postparam, PostHeaders).then((response) => {
              response;
              this.buttonCooldown = false;

              alert("Status Submitted");
            });
            (this.RequestDrop = null),
              (this.location = ""),
              (this.UserEmail = null),
              (this.message = null),
              (this.selected = "Non Urgent"),
              (this.userID = this.$FullName),
              (this.EmailVal = false),
              (this.modal = false);
            this.refreshTable();
          } else {
            alert("Please select a location from the autocomplete list");
            (this.RequestDrop = null),
              (this.location = ""),
              (this.UserEmail = null),
              (this.message = null),
              (this.selected = "Non Urgent"),
              (this.userID = this.$FullName),
              (this.EmailVal = false),
              (this.modal = false);
          }
        }
      }
    },

    /*regExpEscape(literal_string) {
    let changeString = literal_string.replace(/[-\\/\\^$*+?.()|[\]{}]/g, '\\$&');
    let changeString2 = literal_string.replace(/[*+!&%£',?^${}()|[\]\\]/g, '\\$&')
    alert(changeString2)
},*/
  },

  watch: {
    location() {
      this.filterLocations();
    },
    buttonCooldown() {
      this.btnCooldown();
    },
  },
};
</script>
<style scoped>
input[type="text"],
select {
  width: 75%;
  padding: 5px 5px 5px 5px;
  border: solid 1px rgba(200, 200, 200, 0.5);
  background-color: rgb(245, 245, 245);
}
.form-control {
  width: 100%;
  border: solid 1px rgba(200, 200, 200, 0.5);
  border-radius: 25px;
  background-color: rgb(245, 245, 245);
  font-size: 0.9rem;
}

#HeaderText {
  text-align: left;
}

.topContainer {
  margin-top: 10px;
  margin-bottom: 10px;
}

#SupportTable {
  padding: 1.5rem;
}

.BottomRow {
  margin-top: 10px;
  padding-top: 10px;
}

.textPlaceholder {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.line1 {
  margin-top: 3rem;
  margin-bottom: 1rem;
}
#StatusUpdate {
  width: 90%;
  margin-left: 5%;
  margin-bottom: 1rem;
}
#EmailBody {
  width: 90%;
  margin-left: 5%;
  border-radius: 15px;
  padding: 7px 7px 7px;
  border: solid 1px rgb(0, 204, 255);
}
#contactemail {
  width: 75%;
  padding: 5px 5px 5px 5px;
  border: solid 1px rgba(200, 200, 200, 0.5);
  background-color: rgb(245, 245, 245);
}
</style>
